import React from "react";
import "./Terms.scss"
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const Terms= ()=>{
    const lang = localStorage.getItem("lang") ? localStorage.getItem("lang") : "en"
    const history = useHistory()
    const termsArray = [
        {
            id:"1",
            text:{
            en:"By clicking on the above subscribe button, you will agree on the below terms and conditions",
            ar:"بمجرد النقر على زر الاشتراك أعلاه، فإنك توافق على الشروط والأحكام التالية"}
        },
        {
            id:"2",
            text:{
            en:"You will start the paid subscription after the free period automatically",
            ar:"سيبدأ الاشتراك المدفوع بعد انتهاء الفترة المجانية بشكل تلقائي.",}
        },
        {
            id:"3",
            text:{
            en:"Enjoy your Free trial for 24 hours",
            ar:"استمتع بفترة التجربة المجانية لمدة 24 ساعة",}
        },
        {
            id:"4",
            // text: {
            //     en: "No commitment, you can cancel your subscription at any time by sending <span style='font-weight: bold; color: black;'>&lt;C CBD&gt;</span> for <b style='color:black;'>daily pack</b> and <span style='font-weight: bold; color: black;'>&lt;C CBW&gt;</span> for <b style='color:black;'>weekly pack</b> to <b style='color:black;'>&lt;1111&gt;</b> for Etisalat",
            //     ar: "لا يوجد التزام، يمكنك إلغاء اشتراكك في أي وقت عن طريق إرسال <span style='font-weight: bold; color: black;'>&lt;C CBD&gt;</span> للحزمة اليومية و <span style='font-weight: bold; color: black;'>&lt;C CBW&gt;</span> للحزمة الأسبوعية إلى الرقم <b style='color:black;'>&lt;1111&gt;</b> لخدمة اتصالات",
            //   }
            text:{
              en:"No commitment, you can cancel your subscription at any time by sending C CBD for daily pack and C CBW for weekly pack to 1111 for Etisalat",
              ar:"لا يوجد التزام، يمكنك إلغاء اشتراكك في أي وقت عن طريق إرسال C CBD للباقة اليومية و C CBW للباقة الأسبوعية إلى الرقم 1111 لخدمة اتصالات"
            }
        },      
        {
            id:"5",
            text:{
                en:"To get support, please contact contact <b style='color:black;'>@telecubesmobile.com</b>",
                ar:"للحصول على الدعم، يُرجى التواصل عبر البريد الإلكتروني: contact <b style='color:black;'>@telecubesmobile.com</b>",}
        },
        {
            id:"6",
            text:{
                en:"The free trial is valid only for new subscribers",
                ar:" النسخة التجريبية المجانية صالحة فقط للمشتركين الجدد",}
        },
        {
            id:"7",
            text:{
                en:" ",
                ar:" قبل اشتراكك، يمكنك الاطلاع  على كتالوج الألعاب لدينا بالنقر هنا ",}
        },
        {
            id:"8",
            text:{
                en:"Please make sure that your browser is not using any 3rd-party blocking technologies and you have a healthy internet connection for swift access to the content.",
                ar:"يُرجى التأكد من أن متصفحك لا يستخدم أي تقنيات حظر تابعة لجهة خارجية وأن لديك اتصال إنترنت سليم للوصول السريع إلى المحتوى.",}
        },
        {
            id:"9",
            text:{
                en:"",
                ar:" "
            }
        },
        {
            id:"10",
            text:{
                en:"By proceeding, you are accepting all Terms and Conditions of the service and agree to receive updates about your subscription on your registered mobile number.",
                ar:"بمواصلة العملية، أنت توافق على جميع الشروط والأحكام الخاصة بالخدمة وتوافق على تلقي التحديثات حول اشتراكك على رقم الهاتف المحمول المسجل."
            }
        }

    ]

    const openterms=()=>{
       history.push("/terms")
    }

    const openprivacy=()=>{
        history.push("/privacy")
    }

    const openHome=()=>{
        history.push("/")
    }

    return(
        <div className={`terms-container ${lang === "ar" ? "rtl" : ""}`}>
            <div className="heading">{lang === "en" ? "TERMS AND CONDITION" : "الشروط والأحكام"}</div>
        {termsArray.length > 0 && (
        <>
       {termsArray[0].text && <p>{termsArray[0].text[lang]}</p>}

<ul>
  {termsArray.slice(1).map((item, index) =>
    index === 7 ? ( // Check if it's the 8th item (index starts at 0)
      <li key={item.id}>
        {lang === "en"
          ? <>
              Further Terms and conditions 
              <span className="px-1" onClick={openterms} style={{ textDecoration: "underline", color: "black" }}>click here</span>
              & Privacy Policy
              <span className="px-1" onClick={openprivacy} style={{ textDecoration: "underline", color: "black" }}>click here</span>
            </>
          : <>
              لمزيد من الشروط والأحكام 
              <span onClick={openterms} style={{ textDecoration: "underline", color: "black" }}> انقر هنا </span> 
              & سياسة الخصوصية
              <span onClick={openprivacy} style={{ textDecoration: "underline", color: "black" }}> انقر هنا </span>
            </>
        }
      </li>
    ) : index === 5 ? ( // Check if it's the 6th item
      <li key={item.id}>
        {lang === "en"
          ? <>
              Before your subscription, you can consult our catalog of games by
              <span className="px-1" onClick={openHome} style={{ textDecoration: "underline", color: "black" }}>clicking here</span>
            </>
          : <>
              قبل اشتراكك، يمكنك الاطلاع على كتالوج الألعاب لدينا بالنقر
              <span onClick={openHome} style={{ textDecoration: "underline", color: "black" }}>هنا</span>
            </>
        }
      </li>
    ) : (
      <li key={item.id}>
        {item.text && (
          <span dangerouslySetInnerHTML={{ __html: item.text[lang] }}></span>
        )}
      </li>
    )
  )}
</ul>

        </>
      )}
        {/* <ul>
        {lang === "en" ? <li>You will start the paid subscription after the free period automatically.</li>: <li> ستبدأ الاشتراك المدفوع بعد الفترة المجانية تلقائيًا</li>} 
           {lang === "en" ? <li>No commitment, you can cancel your Cubegames Daily subscription at any time by sending C CBD to 1111.</li>: <li> لا يوجد التزام، يمكنك إلغاء اشتراكك اليومي في Cubegames في أي وقت عن طريق إرسال C CBD إلى الرقم 1111.</li>}
           {lang === "en" ? <li>No commitment, you can cancel your Cubegames Weekly subscription at any time by sending C CBW to 1111.</li>:<li> لا يوجد التزام، يمكنك إلغاء اشتراكك في Cubegames Weekly في أي وقت عن طريق إرسال C CBW إلى 1111.</li>} 
           {lang === "en" ? <li>To get support, please contact contact@telecubesmobile.com</li>: <li>للحصول على الدعم، يرجى الاتصال بـ contact@telecubesmobile.com</li>} 
           {lang === "en" ? <li>The free trial is valid only for new subscribers.</li>: <li>التجربة المجانية تاحة للمشتركين الجدد</li>} 
           {lang === "en" ? <li>Enjoy Your Free trial for 24 hours.</li>: <li> استمتع بتجربتك المجانية لمدة 24 ساعة</li>} 
           {lang === "en" ?  <li>Please make sure that your browser is not using any 3rd-party blocking technologies and you have a healthy internet connection for swift access to the content.</li>: <li>يرجى التأكد من أن متصفحك لا يستخدم أي تقنيات حظر تابعة لجهات خارجية وأن لديك اتصال إنترنت للوصول السريع إلى المحتوى.</li>} 
        </ul> */}
        {/* {lang === "en" ?<p>For full terms and conditions, <a href="#/terms">click here</a>.</p>:<p> للحصول على الشروط والأحكام الكاملة، <a href="#terms">انقر هنا</a></p> }  */}
    </div>
    )}

    export default Terms